<div class="grid-container padding-y-4" [formGroup]="downloadForm">
  <div class="grid-row">
   
    <legend class="usa-legend usa-legend--large">{{ title }}</legend>
    
  </div>
  <div class="grid-row grid-gap-0" *ngIf="sysAdmin">
    <div class="grid-col-4">
      <input type="text" class="usa-input" formControlName="scacCode" maxlength="7" placeholder="Enter a SCAC code"
             oninput="this.value = this.value.toUpperCase()">
    </div>
    <div class="grid-col-4">
      <button type="submit" class="usa-button margin-top-1"
              (click)="getFiles()"
              [disabled]="(!this.downloadForm.dirty) || this.downloadForm.get('scacCode').value === ''"
      >Submit
      </button>
    </div>
  </div>
  <div class="grid-row margin-top-2">
    <img src="assets/uswds/img/usa-icons/file_download.svg" alt="user_icon">
    Please click on a file to download it to your desktop.
  </div>
  <div class="grid-row margin-top-2" *ngIf="fileDownload.status === 'error'">
    <div class="usa-alert usa-alert--error usa-alert--slim">
      <div class="usa-alert__body">
        <p class="usa-alert__text">
          {{fileDownload.message}}
        </p>
      </div>
    </div>
  </div>
  <div class="margin-top-2">
      <ag-grid-angular class="ag-theme-alpine"
                       [gridOptions]="gridOptions"
                       [rowData]="downloadFileList"
                       (gridReady)="onGridReady($event)"
                       [getRowHeight]="getRowHeight">
      </ag-grid-angular>
  </div>
</div>
